import { render, staticRenderFns } from "./DocumentacionIframe.vue?vue&type=template&id=1de7e0a2"
import script from "./DocumentacionIframe.vue?vue&type=script&lang=js"
export * from "./DocumentacionIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports